export const PRINTED_ADOPTION = 'printed-adoption';
export const HANDOFF_ADOPTION = 'handoff-adoption';
export const NEW_USER_TAG_ADOPTION = 'new-user-tag-adoption';
export const HIGH_VALUE_USER_TAG_ADOPTION = 'high-value-user-tag-adoption';
